import useStoreLinks, {
  StoreType,
} from "../../../../common/features/store/useStoreLinks.ts";
import { useIntl } from "react-intl";
import peopleImg from "./img/people.jpg";
import booksImg from "./img/books.jpg";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import { useHomeContextUser } from "../../homeContext.ts";

interface MainItem {
  title: string;
  body?: string;
  linkText: string;
  href?: string;
  to?: string;
  imgSrc: string;
}

export default function useBigPromo() {
  const intl = useIntl();
  const brand = useBrandLoaderData();
  const user = useHomeContextUser();
  const { storeType, makeBasicStoreURL } = useStoreLinks();

  const VitalsourceStorePromo: MainItem = {
    title: intl.formatMessage({
      defaultMessage: "Save up to 80% with eTextbooks from VitalSource",
    }),
    body: undefined,
    linkText: intl.formatMessage({
      // Regional stores also use .com
      // Don't worry about dev cases pointed at vitalbook.com
      defaultMessage: "Shop VitalSource.com",
    }),
    href: makeBasicStoreURL({
      utm_medium: "bookshelf-home-promobox",
    }),
    imgSrc: peopleImg,
  };
  const WhiteLabelAndThirdPartyStorePromo: MainItem = {
    title: intl.formatMessage({
      defaultMessage: "Find additional eTextbooks on our Store!",
    }),
    body: undefined,
    linkText: intl.formatMessage({
      defaultMessage: "Shop Now",
    }),
    href: makeBasicStoreURL({
      utm_medium: "bookshelf-home-promobox",
    }),
    imgSrc: peopleImg,
  };
  const ExplorePromo: MainItem = {
    title: intl.formatMessage({
      defaultMessage: "Explore content available to you",
    }),
    body: intl.formatMessage({
      defaultMessage: "Discover the books available to read right now!",
    }),
    linkText: intl.formatMessage({ defaultMessage: "Explore" }),
    to: "/explore",
    imgSrc: booksImg,
  };

  if (storeType === StoreType.VitalSource) {
    return VitalsourceStorePromo;
  }
  if (
    storeType === StoreType.VitalSourceWhiteLabel ||
    storeType === StoreType.ThirdParty
  ) {
    return WhiteLabelAndThirdPartyStorePromo;
  }
  if (brand.Explore.enabled && user.hasExplore) {
    return ExplorePromo;
  }
  return undefined;
}
